<template>
  <v-list-item elevation="1" two-line class="offwhite mx-5 my-2" :class="{'phantom':artistIsPhantom}">
      <template #prepend>
        <v-avatar size="40">
          <v-img :src="artist.profilePicture?'data:image/png;base64,'+artist.profilePicture : require('@/assets/Placeholder-Profile-819x1024.webp')"/>
        </v-avatar>
      </template>
    <template #title>
      <span class="font-weight-bold mr-5" style="font-size: 1.3rem;" v-html="artist.name"></span><v-chip x-small v-for="year in artist.years" :key="year">{{year}}</v-chip>

    </template>
    <template #subtitle>
      <span v-for="(profession,index) of artist.professions" :key="index">
      <span class="mx-1" v-text="profession.company?.name"></span>
      <span v-if="index < artist.professions.length-1">|</span>
    </span>
    </template>
    <template #append>
      <div class="d-flex flex-column align-center">
      <v-menu
          offset-y
          bottom
          left
      >
        <template v-slot:activator="{ props }">
          <v-btn
              dark
              icon
              variant="flat"
              v-bind="props"
          >
            <v-icon color="primary">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-dialog v-model="showEditArtistDialog">
            <template #activator="{props}">
              <v-list-item link title="Edit Artist" v-bind="props">
                <template #prepend>
                  <v-icon>mdi-pencil</v-icon>
                </template>
              </v-list-item>
            </template>
            <EditUserDialogContent @update="update" @toggle="(value) => this.showEditArtistDialog = value" :user-id="artistC.id"/>
          </v-dialog>
          <v-dialog v-model="showShareDialog" persistent v-if="isMyArtist || hasRoleAdmin">
            <template v-slot:activator="{props}">
              <v-list-item title="Share Artist" link v-bind="props">
                <template #prepend>
                  <v-icon>mdi-share</v-icon>
                </template>
              </v-list-item>
            </template>
            <v-card>
              <v-card-text class="pa-5">

                <ShareToUser @updateShareList="updateArtistShareList" :editable-by="artist.editableBy"/>
                <div class="d-flex justify-end">
                  <v-btn @click="showShareDialog = false" icon><v-icon>mdi-close</v-icon></v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-list-item prepend-icon="mdi-send" link title="Send Credentials to email" @click="sendInvite" >
            <template #subtitle>
              Email is send to {{artistC.email}}
            </template>

          </v-list-item>
          <v-list-item prepend-icon="mdi-delete" title="Delete User" link @click="deleteUser">

          </v-list-item>
        </v-list>
      </v-menu>
      <v-switch :loading="loadVisibility" v-if="hasRoleAdmin" :color="artistC.visibleOnWebsite ? 'success' : 'grey'" inset density="compact" @change="toggleWebsiteVisibilityArtist" v-model="artistC.visibleOnWebsite">
        <template #label>
          <v-icon color="success" v-if="artistC.visibleOnWebsite">mdi-eye</v-icon>
          <v-icon v-else>mdi-eye-closed</v-icon>
        </template>
      </v-switch>
      </div>
    </template>



    <v-tooltip right>
      <template #activator="{props}">
        <v-icon v-bind="props" style="position:absolute;left:0;top:0;" class="pa-2" v-if="artistIsPhantom">mdi-ghost</v-icon>

      </template>
      This User has a temporary Email and has not logged in in his account.
    </v-tooltip>

  </v-list-item>
</template>

<script>
import {shareArtist, toggleWebsiteVisibilityArtist} from "@/services/artist.service";
import Artist from "@/models/Artist";
import ShareToUser from "@/components/share/ShareToUser";
import {deleteUser, inviteUser} from "@/services/user.service";
import EditUserDialogContent from "@/components/user/EditUserDialogContent";

export default {
  name: "ArtistListItem",
  components: {EditUserDialogContent, ShareToUser},
  props:{
    artist: Object
  },
  data(){
    return{
      showEditArtistDialog:false,
      showShareDialog :false,
      loadVisibility:false
    }
  },
  computed:{
    artistC:{
      get(){
        return this.artist;
      },
      set(artist){
        this.$emit("updateArtist",artist);
      }
    },

    currentUser(){
      return this.$store.state.auth.user;
    },
    hasRoleAdmin(){
      return this.currentUser.roles.includes("ROLE_ADMIN");
    },
    artistIsPhantom(){
      return this.artistC.roles.includes("ROLE_PHANTOM");
    },
    isMyArtist(){
      return this.artist.createdBy === this.currentUser.id;
    },
  },
  methods:{
    async deleteUser() {
      if(confirm("Are you sure?"))
      {
        let success = await deleteUser(this.artistC.id);
        if (success) this.$emit("deleteUser", this.artistC.id);
      }
    },
    update(artist){
      this.$emit("updateArtist",artist);
    },
    async sendInvite() {
      if (confirm("Are you sure? By clicking OK the Artist gets an Welcome Email with his new Details. The Password gets reset.")){
        await inviteUser(this.artistC.id);
    }
    },
    async updateArtistShareList(ids) {
      await shareArtist(this.artist.id, ids);
      this.showShareDialog = false;
    },
    async toggleWebsiteVisibilityArtist() {
      try{
        await toggleWebsiteVisibilityArtist(this.artist.id, this.artist.visibleOnWebsite);
      }catch (e) {
        this.artistC.visibleOnWebsite = !this.artistC.visibleOnWebsite;
      }finally {
        this.loadVisibility =false;
      }
    }
  }
}
</script>

<style scoped>
.phantom{
  opacity: 0.7;
}
</style>